// extracted by mini-css-extract-plugin
export default {"link":"yR-z","disabled":"zR-z"};